import set from "@rill/set";
import rill from "rill";
import { triggerClientConfigMigration } from "../../../middleware/trigger-client-config-migration.js";

import getCalendarDay from "./calendar-day.controller";
import getCalendarMonth from "./calendar-month.controller";
import getCalendarWeek from "./calendar-week.controller";

const Calendar = (app) => {
  app.at(
    "/calendar/*",
    rill()
      .use(set("heading", ["Athlete", "Calendar"]))
      .setup((app) =>
        app.get(
          "/",
          triggerClientConfigMigration,
          getCalendarDay,
          getCalendarWeek,
          getCalendarMonth
        )
      )
  );
};

export default Calendar;
